import type { ReactElement } from "react";

import { FilterResultContainer } from "app/pages/sales-intelligence/common-components/filters-panel/components/styles";

import { GroupField } from "./GroupField";
import type { GroupViewProps } from "./types";

const DEFAULT_VALUE = {};

export const DynamicGroupFilterResultView = ({
    filter,
    value = DEFAULT_VALUE,
    isActionEnabled,
    onFilterUpdate,
}: GroupViewProps): ReactElement | null => {
    if (filter.isValueEmpty(value)) {
        return null;
    }

    return (
        <FilterResultContainer>
            {filter.getFields().map((field) => (
                <GroupField
                    key={field.key}
                    group={filter}
                    field={field}
                    groupValue={value}
                    isActionEnabled={isActionEnabled}
                    onFilterUpdate={onFilterUpdate}
                    view={field.filterResultView}
                />
            ))}
        </FilterResultContainer>
    );
};
